import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Payments from '../Payments';
import { getPage, hasError } from '../../../states/page/selectors';
import { goBackPage, resetApp, pages, goToPage, goToPreviousPage } from '../../../states/page/actions';
import withCalendar from '../../../containers/withCalendar';

import { isBatchEligible } from '../../../states/payments/selectors';
import { canShowPaymentTabs } from '../../../states/accounts/selectors';
import Review from '../Review/Review';
import Confirmed from '../Confirmed/Confirmed';
import { isBatch, isBatchTypeUpload } from '../../../states/batch/selectors';
import { toggleBatch } from '../../../states/batch/actions';
import PaymentsLandingPage from '../PaymentsLandingPage/PaymentsLandingPage';
import AddPayeeLayoutContainer from '../../../payees/components/LayoutContainer';
import { fetchStatusCodeMapping } from '../../../states/statusMapping/actions';
import { submitReview, submitConfirmed } from '../../../states/api/fasterPaymentActions';
import { connectWrapper as ImportedFasterPaymentsPage } from '../../../importedPayments/components/fps/ImportedPaymentsPage';
import { getImportedPaymentList } from '../../../states/importedPaymentList/selector';
import FPPayeePage from '../FPPayeePage/FPPayeePage';
import AccountPickerPage from '../../../sharedComponents/AccountPickerPage/AccountPickerPage';
import PaymentTimedOutModal from '../../../sharedComponents/PaymentTimedOutModal';
import { TYPE_FASTER_PAYMENTS } from '../../../config';
import { resetEffectiveWarning } from '../../../effectiveWarning/state/actions';
import { PaymentType } from '../../../effectiveWarning/utils/constants';
import EffectiveWarningSMEContainer from '../../../effectiveWarning/EffectiveWarningSMEContainer';
import { setSelectedPaymentId } from '../../../states/payeeSelector/actions';
import { session } from '../../../../dev/stubs/props';

const mapState = (state) => ({
	page: getPage(state),
	hasError: hasError(state),
	isBatch: isBatch(state),
	isBatchTypeUpload: isBatchTypeUpload(state),
	isBatchEligible: isBatchEligible(state),
	showPaymentTabs: canShowPaymentTabs(state),
	importedPaymentList: getImportedPaymentList(state),
});

const mapDispatch = (dispatch) => ({
	handleSubmitPaymentsForReview: () => dispatch(submitReview()),
	handleSubmitConfirmedPayments: () => dispatch(submitConfirmed()),
	handleBack: () => dispatch(goBackPage()),
	toggleBatch: (value) => dispatch(toggleBatch(value)),
	reset: () => dispatch(resetApp),
	fetchStatusCodeMapping: () => dispatch(fetchStatusCodeMapping()),
	goToPage: (page) => dispatch(goToPage(page)),
	resetEffectiveWarning: () => dispatch(resetEffectiveWarning()),
	goToPreviousPage: () => dispatch(goToPreviousPage()),
	setSelectedPaymentId: () => dispatch(setSelectedPaymentId()),
});

class LayoutContainer extends Component {
	constructor(props) {
		super(props);

		this.handleContinue = this.handleContinue.bind(this);
		this.handleBackClick = this.handleBackClick.bind(this);
		this.handleReset = this.handleReset.bind(this);
	}
	componentDidMount() {
		this.props.fetchStatusCodeMapping();
	}

	componentDidUpdate() {
		const { hasError, handleRoute, isBatchEligible, isBatch, toggleBatch, isBatchTypeUpload } = this.props;

		if (hasError) {
			handleRoute('WEB-ERROR');
		} else if (!isBatchEligible && isBatch && !isBatchTypeUpload) {
			toggleBatch(false);
		}
	}

	handleBackClick() {
		const { handleBack, handleBackParent, page, setSelectedPaymentId } = this.props;
		if (page === pages.FasterPayments && handleBackParent) {
			handleBackParent();
			return;
		}
		setSelectedPaymentId();
		handleBack();
	}
	handleContinue() {
		const { page, handleSubmitPaymentsForReview, handleSubmitConfirmedPayments } = this.props;
		switch (page) {
			case pages.ImportedFasterPaymentsPage:
			case pages.FasterPayments:
				handleSubmitPaymentsForReview();
				break;
			case pages.FasterPaymentsReview:
			case pages.EffectiveWarning.warning:
			case pages.EffectiveWarning.paymentReason:
				handleSubmitConfirmedPayments();
				break;
			default:
				break;
		}
	}

	handleReset() {
		const { resetPaymentList, reset, resetEffectiveWarning } = this.props;
		resetEffectiveWarning();
		resetPaymentList();
		reset();
	}

	renderPage() {
		const {
			copCheckTriggered,
			page,
			handleRoute,
			handleBackParent,
			handleComplete,
			handleDisplayFullwidth,
			handlePaymentInReview,
			handleSelectPaymentType,
			showPaymentTabs,
			isBootStrapInProgress,
			importedPaymentList,
			goToPreviousPage,
			sessionCOPChecks,
		} = this.props;
		switch (page) {
			case pages.FasterPaymentsLandingPage:
				return (
					<PaymentsLandingPage
						showPaymentTabs={showPaymentTabs}
						handleContinue={this.handleContinue}
						handleDisplayFullwidth={handleDisplayFullwidth}
						handleSelectPaymentType={handleSelectPaymentType}
						isBootStrapInProgress={isBootStrapInProgress}
					/>
				);
			case pages.FasterPayments:
				return (
					<div className="container container--lg">
						<Payments
							copCheckTriggered={copCheckTriggered}
							handleContinue={this.handleContinue}
							handleBack={this.handleBackClick}
							handleRoute={handleRoute}
							handleDisplayFullwidth={handleDisplayFullwidth}
							sessionCOPChecks={sessionCOPChecks}
						/>
					</div>
				);
			case pages.FasterPaymentsReview:
				this.props.handleDisplayFullwidth();
				return (
					<div className="container container--lg">
						<PaymentTimedOutModal handleRoute={handleRoute} />
						<Review
							handleContinue={this.handleContinue}
							handleBack={this.handleBackClick}
							handleRoute={handleRoute}
							handleBackParent={handleBackParent}
							handlePaymentInReview={handlePaymentInReview}
							contentKey="content"
						/>
					</div>
				);
			case pages.FasterPaymentsSubmitted:
				return (
					<div className="container container--lg">
						<Confirmed handleRoute={handleRoute} handleReset={this.handleReset} handleComplete={handleComplete} />
					</div>
				);
			case 'Payee':
				return (
					<div className="container container--lg">
						<AddPayeeLayoutContainer
							copCheckTriggered={copCheckTriggered}
							id="addPayee"
							handleRoute={handleRoute}
							sessionCOPChecks={sessionCOPChecks}
						/>
					</div>
				);
			case 'PaymentsEditTemplate':
				return (
					<div className="container container--lg">
						<Payments
							copCheckTriggered={copCheckTriggered}
							handleContinue={() => {}}
							handleBack={this.handleBackClick}
							handleRoute={handleRoute}
							handleDisplayFullwidth={handleDisplayFullwidth}
							sessionCOPChecks={sessionCOPChecks}
							templateMode
						/>
					</div>
				);
			case 'PaymentsCreateNewTemplate':
				return (
					<div className="container container--lg">
						<Payments
							copCheckTriggered={copCheckTriggered}
							handleContinue={() => {}}
							handleBack={this.handleBackClick}
							handleRoute={handleRoute}
							handleDisplayFullwidth={handleDisplayFullwidth}
							sessionCOPChecks={sessionCOPChecks}
							templateMode
						/>
					</div>
				);
			case pages.ImportedFasterPaymentsPage:
				return (
					<div className="container container--lg">
						<ImportedFasterPaymentsPage
							handleContinue={this.handleContinue}
							handleDisplayFullwidth={handleDisplayFullwidth}
							handlePaymentInReview={handlePaymentInReview}
							handleBack={this.handleBackClick}
							importedPaymentList={importedPaymentList}
							type={TYPE_FASTER_PAYMENTS}
						/>
					</div>
				);
			case pages.FasterPaymentsPayeeSelector:
				return (
					<FPPayeePage
						copCheckTriggered={copCheckTriggered}
						handleDisplayFullwidth={handleDisplayFullwidth}
						sessionCOPChecks={sessionCOPChecks}
					/>
				);
			case pages.FasterPaymentsAccountPicker:
				return <AccountPickerPage pageId={pages.FasterPaymentsLandingPage} />;
			case pages.EffectiveWarning.paymentReason:
			case pages.EffectiveWarning.warning:
			case pages.EffectiveWarning.paymentCancelled:
				return (
					<div className="container container--lg">
						<PaymentTimedOutModal handleRoute={handleRoute} />
						<EffectiveWarningSMEContainer
							payType={PaymentType.FPS}
							listPayType={PaymentType.LIST_FPS}
							batchPayType={PaymentType.BATCH_FPS}
							onContinue={this.handleContinue}
							onError={() => handleRoute('WEB-HOMEPAGE')}
							handleBack={goToPreviousPage}
							startPage={page}
							onCancel={this.handleReset}
							handlePaymentInReview={handlePaymentInReview}
							handleRoute={handleRoute}
						/>
					</div>
				);
			default:
				return null;
		}
	}

	render() {
		return <div>{this.renderPage()}</div>;
	}
}

LayoutContainer.defaultProps = {
	resetPaymentList: () => {},
	handleDisplayFullwidth: () => {},
	handlePaymentInReview: () => {},
};

LayoutContainer.propTypes = {
	page: PropTypes.string.isRequired,
	fetchStatusCodeMapping: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	handleBackParent: PropTypes.func,
	handleSubmitPaymentsForReview: PropTypes.func.isRequired,
	hasError: PropTypes.bool,
	handleRoute: PropTypes.func,
	handleSubmitConfirmedPayments: PropTypes.func.isRequired,
	handleComplete: PropTypes.func,
	isBatch: PropTypes.bool.isRequired,
	isBatchEligible: PropTypes.bool.isRequired,
	toggleBatch: PropTypes.func.isRequired,
	resetPaymentList: PropTypes.func,
	handlePaymentInReview: PropTypes.func,
	reset: PropTypes.func.isRequired,
	handleDisplayFullwidth: PropTypes.func,
	handleSelectPaymentType: PropTypes.func.isRequired,
	showPaymentTabs: PropTypes.bool.isRequired,
	isBootStrapInProgress: PropTypes.bool.isRequired,
	importedPaymentList: PropTypes.shape([]),
	isBatchTypeUpload: PropTypes.bool.isRequired,
	resetEffectiveWarning: PropTypes.func.isRequired,
	goToPreviousPage: PropTypes.func,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
};

export default connect(mapState, mapDispatch)(withCalendar(LayoutContainer));
